import React, { useState, useEffect } from "react";
import assets from "../../assets/assets";
import { useLocation } from "react-router-dom"; // Import useLocation hook from react-router-dom

const Navbar = () => {
  const { business_logo, business_logo_dark } = assets();
  const [scrolling, setScrolling] = useState(false);
  const location = useLocation(); // This hook gives you access to the current route

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 50) {
        setScrolling(true);
      } else {
        setScrolling(false);
      }
    };

    // Attach scroll listener
    window.addEventListener("scroll", handleScroll);

    // Cleanup function to remove the event listener
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []); // Empty dependency array ensures this effect runs only once on mount

  return (
    <header>
      <nav
        className={`navbar navbar-expand-lg ${
          scrolling
            ? "bg-white text-dark shadow-sm"
            : "header-transparent bg-transparent text-white"
        } header-reverse glass-effect`}
        style={{
          transition: "all 0.5s ease",
        }}
        data-header-hover="light"
      >
        <div className="container-fluid">
          <div className="col-auto col-xxl-3 col-lg-2 me-lg-0 me-auto">
            <a className="navbar-brand" href="/">
              {scrolling ? (
                <img
                  src={business_logo_dark}
                  alt="Logo"
                  className="default-logo"
                  srcSet={business_logo_dark}
                />
              ) : (
                <>
                  <img
                    src={business_logo}
                    alt="Logo"
                    className="default-logo namvarlogomain"
                    srcSet={business_logo}
                  />
                  <img
                    src={business_logo}
                    alt="Logo"
                    className="default-logo namvarlogo"
                    srcSet={business_logo_dark}
                  />
                </>
              )}
            </a>
          </div>
          <div className="col-auto col-xxl-6 col-lg-8 menu-order position-static">
            <button
              className="navbar-toggler float-start"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#navbarNav"
              aria-controls="navbarNav"
              aria-label="Toggle navigation"
            >
              <span className="navbar-toggler-line"></span>
              <span className="navbar-toggler-line"></span>
              <span className="navbar-toggler-line"></span>
              <span className="navbar-toggler-line"></span>
            </button>
            <div
              className="collapse navbar-collapse justify-content-center"
              id="navbarNav"
            >
              <ul className="navbar-nav" style={{ gap: "1rem" }}>
                <li className="nav-item" style={{ cursor: "pointer" }}>
                  <a
                    href="/"
                    className={`nav-link ${
                      scrolling ? "text-dark" : "text-white"
                    }`}
                  >
                    Home
                  </a>
                </li>
                <li className="nav-item" style={{ cursor: "pointer" }}>
                  <a
                    href="/our-history"
                    className={`nav-link ${
                      scrolling ? "text-dark" : "text-white"
                    }`}
                  >
                    Our History
                  </a>
                </li>
                <li className="nav-item dropdown dropdown-with-icon-style02">
                  <a
                    href="/services"
                    className={`nav-link ${
                      scrolling ? "text-dark" : "text-white"
                    }`}
                  >
                    Services
                  </a>
                  {/* <i
                    className="fa-solid fa-angle-down dropdown-toggle text-light"
                    id="navbarDropdownMenuLink"
                    role="button"
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                  ></i>
                  <ul
                    className="dropdown-menu"
                    aria-labelledby="navbarDropdownMenuLink"
                  >
                    <li>
                      <a
                        href="#"
                        className="text-white"
                      >
                        <i className="bi bi-briefcase"></i>Data analytics
                      </a>
                    </li>
                    <li>
                      <a
                        href="$"
                        className="text-white"
                      >
                        <i className="bi bi-clipboard-data"></i>Finance
                        consulting
                      </a>
                    </li>
                    <li>
                      <a
                        href="#"
                        className="text-white"
                      >
                        <i className="bi bi-peace"></i>Technology innovation
                      </a>
                    </li>
                    <li>
                      <a
                        href="#"
                        className="text-white"
                      >
                        <i className="bi bi-bar-chart-line"></i>Digital commerce
                      </a>
                    </li>
                    <li>
                      <a
                        href="#"
                        className="text-white"
                      >
                        <i className="bi bi-send-check"></i>Artificial
                        intelligence
                      </a>
                    </li>
                    <li>
                      <a
                        href="demo-it-business-services-details.html"
                        className="text-white"
                      >
                        <i className="bi bi-globe2"></i>Cloud computing
                      </a>
                    </li>
                  </ul> */}
                </li>
                <li className="nav-item">
                  <a
                    href="/our-concern"
                    className={`nav-link ${
                      scrolling ? "text-dark" : "text-white"
                    }`}
                  >
                    Our Concern
                  </a>
                </li>
                <li className="nav-item">
                  <a
                    href="/Career"
                    className={`nav-link ${
                      scrolling ? "text-dark" : "text-white"
                    }`}
                  >
                    Career
                  </a>
                </li>
                <li className="nav-item">
                  <a
                    href="/contact"
                    className={`nav-link ${
                      scrolling ? "text-dark" : "text-white"
                    }`}
                  >
                    Contact
                  </a>
                </li>
              </ul>
            </div>
          </div>
          <div className="col-auto col-xxl-3 col-lg-2 text-end d-none d-sm-flex">
            <div className="header-icon">
              <div className="header-button">
                <a
                  href="#"
                  className={`btn btn-large  btn-rounded text-transform-none border-1 ${
                    scrolling
                      ? "btn-transparent-white-dark"
                      : "btn-transparent-white-light"
                  }`}
                >
                  Start a project
                  <i className="fa-solid fa-arrow-right"></i>
                </a>
              </div>
            </div>
          </div>
        </div>
      </nav>
    </header>
  );
};
export default Navbar;
